export { default as AdExchangeComponent } from './AdExchangeComponent';
